// extracted by mini-css-extract-plugin
export default {"container":"WidgetCompass_container__kfjB1","compassContaier":"WidgetCompass_compassContaier__pJO3e","arrowImage":"WidgetCompass_arrowImage__touVW"};